"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgeStylesMixin = void 0;

var _styledComponents = require("styled-components");

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var badgeTextStyles = (0, _styledComponents.css)(["", ";font-size:", ";", ";text-align:center;text-transform:uppercase;vertical-align:inherit;hyphens:manual;"], _Styles.FONT_FAMILIES.bold, _sizes.BADGE_ROUNDED_FONT_SIZE, (0, _Styles.setFontSmoothing)('antialiased'));
var badgeStylesMixin = (0, _styledComponents.css)(["display:inline-block;", ";", ";line-height:", ";min-height:", ";"], badgeTextStyles, (0, _Styles.setBorderRadius)(), _sizes.BADGE_ROUNDED_HEIGHT, _sizes.BADGE_ROUNDED_HEIGHT);
exports.badgeStylesMixin = badgeStylesMixin;